<template>
  <v-container id="categorias" tag="section">
    <base-v-component heading="CARTA DIGITAL DEL RESTAURANTE" />
    <base-material-card color="indigo" icon="mdi-newspaper" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-btn color="success" :loading="loadingForm" dark class="mb-2" @click.stop="save()">Guardar</v-btn>
        <v-spacer />
      </v-toolbar>
      <v-row justify="center" no-gutters>
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title>
              <v-spacer />
              <h4 class="text-center">PDF Carta</h4>
              <v-spacer />
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-checkbox v-model="carta.redireccionar" label="Redireccionar PDF" />
                </v-col>

                <v-col cols="12" sm="6" v-if="!carta.pdf">
                  <v-file-input value="hola" accept="pdf/*" label="Carta en PDF" v-model="pdfFile"></v-file-input>
                </v-col>
                <v-col cols="12" sm="3" v-if="carta.pdf">
                  <v-btn @click="carta.pdf = null" class="grey">Subir una nueva carta</v-btn>
                </v-col>
                <v-col cols="12" sm="3" v-if="carta.pdf">
                  <v-btn @click="openUrl(carta.pdf)" class="secondary">URL CARTA</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      loadingForm: false,
      carta: {
        pdf: "",
        redireccionar: false,
      },
      pdfFile: null,
    };
  },
  computed: {
    ...mapGetters({
      negocioObj: ["app/negocioGestObj"],
      restObj: ["app/restGestObj"],
    }),
  },
  methods: {
    openUrl(url) {
      window.open(url, "_blank");
      return false;
    },
    save() {
      let _vm = this;
      _vm.loadingForm = true;
      this.$store
        .dispatch("carta/saveCartaRest", {
          carta: this.carta,
          file: this.pdfFile,
        })
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Carta restaurante guardada",
          });
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido guardar la redirección: " + e,
          });
        })
        .finally(() => {
          _vm.loadingForm = false;
        });
    },
  },
  mounted() {
    if (this.restObj && this.restObj.carta) {
      this.carta = this.restObj.carta;
    }
  },
};
</script>

<style>
</style>